import ListScreen, { smallAccentTitleRoleObj } from './ListScreen';

export { smallAccentTitleRoleObj };
export default ListScreen;
